import React from "react";
import { Toast } from "antd-mobile";
import "./index.less";
import { post } from "../../utils/request";
import api from "../api";

class MethanolSiteDetail extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      mapAppType: false,
      detailData: {},
    };
  }
  componentDidMount() {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = window.location.hash.split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }
      this.setState(
        {
          urlOps: ops,
        },
        () => {
          this.getDetail();
        }
      );
    }
  }

  getDetail() {
    const { urlOps } = this.state;
    post({
      url: api.getMethanolStationByCode + "?app_stoken=" + urlOps.app_stoken,
      data: {
        stationCode: urlOps.stationCode,
      },
    }).then(
      (res) => {
        console.log(res);
        if (res.result === "success") {
          this.setState({
            detailData: res.data,
          });
        }
      },
      (res) => {
        console.log("查询详情失败", res);
        if (res.code == "-1") {
          Toast.info("登录失效", 1);
        }
      }
    );
  }
  openMapApp() {
    const { detailData } = this.state;
    this.setState({
      mapAppType: true,
      appParame: {
        latitude: detailData.latitude,
        longitude: detailData.longitude,
        name: detailData.address,
      },
    });
  }
  openApp(type) {
    const { name, latitude, longitude } = this.state.appParame;
    let url;
    let lat, long;
    const u = navigator.userAgent;
    //判断ios
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    //判断Android
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    if (type == 1) {
      //百度地图 把获取到的非百度坐标转为百度坐标
      const { latitude, longitude } = this.transformFromGCJToBaidu(
        latitude,
        longitude
      );
      lat = latitude;
      long = longitude;
    } else if (type == 2) {
      //高德地图 把获取到的非GCJ-02坐标转为GCJ-02(火星坐标)
      lat = latitude;
      long = longitude;
    }
    if (isAndroid) {
      switch (type) {
        case 1: //百度地图
          //   url = `http://api.map.baidu.com/marker?location=${lat},${long}&title=${name}&content=${name}&output=html`;
          url = `baidumap://map/direction?mode=driving&destination=latlng:${lat},${long}|name:${name}&coord_type=gcj02`;
          break;
        case 2: //高德地图
          //   url = `androidamap://viewMap?sourceApplication=appname&poiname=${name}&lat=${lat}&lon=${long}&dev=0`;
          url = `amapuri://route/plan/?did=&dlat=${lat}&dlon=${long}&dname=${name}&dev=0&t=0`;
          break;
        default:
          break;
      }
    } else if (isIOS) {
      switch (type) {
        case 1: //百度地图
          //   url = `http://api.map.baidu.com/marker?location=${lat},${long}&title=${name}&content=${name}&output=html`;
          url = `baidumap://map/direction?destination=latlng:${lat},${long}|name:${name}&mode=driving&coord_type=gcj02`;
          break;
        case 2: //高德地图
          //   url = `http://uri.amap.com/marker?position=${long},${lat}&name=${name}&src=mypage&coordinate=gaode&callnative=00`;
          url = `iosamap://navi?lat${lat}&lon=${long}&dev=0&style=2`;
          break;
        default:
          break;
      }
    }
    window.location.href = url;
  }
  // 将GCJ-02(火星坐标)转为百度坐标
  transformFromGCJToBaidu(latitude, longitude) {
    var pi = (3.14159265358979324 * 3000.0) / 180.0;

    var z =
      Math.sqrt(longitude * longitude + latitude * latitude) +
      0.00002 * Math.sin(latitude * pi);
    var theta =
      Math.atan2(latitude, longitude) + 0.000003 * Math.cos(longitude * pi);
    var a_latitude = z * Math.sin(theta) + 0.006;
    var a_longitude = z * Math.cos(theta) + 0.0065;

    return {
      latitude: a_latitude,
      longitude: a_longitude,
    };
  }

  render() {
    const { mapAppType, detailData } = this.state;
    return (
      <div className="MethanolSiteDetailBox">
        <div className="contentBox">
          <div className="title">{detailData.stationName}</div>
          <div className="addressBox">
            <div className="address">{detailData.address}</div>
            {/* <div
              className="mapBtn"
              onClick={() => {
                this.openMapApp();
              }}
            >
              导航
            </div> */}
          </div>
        </div>
        <div className="contentBox">
          {detailData.offers ? (
            <div className="warningBox">
              优惠信息:
              <br />
              {detailData.offers}
            </div>
          ) : (
            ""
          )}

          <div className="textList">
            <div>
              营业时间：
              {["", "按整周", "按周日期"][detailData.businessHoursType]}
            </div>
            <div>充电桩营业时间：{detailData.openTimeRemark || "-"}</div>
            <div>停车费说明：{detailData.parkingFeeRemark || "-"}</div>
          </div>
        </div>
        {mapAppType ? (
          <div className="contentMobileSearchResult">
            <div className="contentMobileSearchResultBox">
              <div className="resultTitle">
                <div>请选择地图APP</div>
                <div
                  onClick={() => {
                    this.setState({
                      mapAppType: false,
                    });
                  }}
                >
                  取消
                </div>
              </div>
              <div className="resultList">
                <div>
                  <div
                    onClick={() => {
                      this.openApp(2);
                    }}
                  >
                    高德地图
                  </div>
                  <div
                    onClick={() => {
                      this.openApp(1);
                    }}
                  >
                    百度地图
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default MethanolSiteDetail;



// WEBPACK FOOTER //
// ./src/MethanolSite/detail/index.js